import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/page/index'
import Report from '@/page/report'
import Service from '@/page/service'
import News from '@/page/news'
import NewsInfo from '@/page/newsInfo'
import Form from '@/page/form'
import Start from '@/page/start'
import Notice from '@/page/notice'
import Notices from '@/page/notices'
import Services from '@/page/services'

import Page from '@/page/page'
import InfoNew from '@/page/infoNew'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'start',
      component: Start,
      meta:{
        title: '麻丘镇',
        keepAlive: false
      }
    },
    {
      path: '/page',
      name: 'page',
      component: Page,
      meta:{
        title: '三务公开',
        keepAlive: false
      }
    },
    {
      path: '/start',
      name: 'start',
      component: Start,
      meta:{
        title: '麻丘镇',
        keepAlive: false
      }
    },
    {
      path: '/index',
      name: 'index',
      component: Index,
      meta:{
        title: '麻丘镇',
        keepAlive: false
      }
    },
    {
      path: '/notice',
      name: 'notice',
      component: Notice,
      meta:{
        title: '举报须知',
        keepAlive: false
      }
    },
    {
      path: '/notices',
      name: 'notices',
      component: Notices,
      meta:{
        title: '举报须知',
        keepAlive: false
      }
    },
    {
      path: '/report',
      name: 'report',
      component: Report,
      meta:{
        title: '一键举报',
        keepAlive: false
      }
    },
    {
      path: '/service',
      name: 'service',
      component: Service,
      meta:{
        title: '三务公开',
        keepAlive: false
      }
    },
    {
      path: '/services',
      name: 'services',
      component: Services,
      meta:{
        title: '三务公开',
        keepAlive: false
      }
    },
    {
      path: '/news',
      name: 'news',
      component: News,
      meta:{
        title: '三务公开',
        keepAlive: true
      }
    },
    {
      path: '/newsInfo',
      name: 'newsInfo',
      component: NewsInfo,
      meta:{
        title: '三务公开',
        keepAlive: false
      }
    },
    {
      path: '/form',
      name: 'form',
      component: Form,
      meta:{
        title: '一键举报',
        keepAlive: false
      }
    },
    {
      path: '/infoNew',
      name: 'infoNew',
      component: InfoNew,
      meta:{
        title: '明细',
        keepAlive: false
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js